export default __webpack_public_path__ + "static/media/Averta-Light.3611691e.ttf";